import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { API_ENDPOINTS } from '../../configs/api.config';
import { authRequest } from '../../configs/axios';

const initialState = {
  ordersState: [],
  status: 'idle',
  pagination: {
    totalElements: 0,
    totalPages: 0,
    size: 10,
    number: 0,
  },
};

export const postOrdersAsync = createAsyncThunk(
  'orders/postOrdersAsync',
  async (payload) => {
    const response = await authRequest.post(API_ENDPOINTS.ORDERS, payload);
    return response.data;
  }
);

export const loadOrdersAsync = createAsyncThunk(
  'orders/loadOrdersAsync',
  async ({ page = 0, size = 10 } = {}) => {
    // Backend automatically returns orders for logged-in customer
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('size', size);

    const response = await authRequest.get(`${API_ENDPOINTS.ORDERS}?${params.toString()}`);
    return response.data;
  }
);

export const updateOrdersAsync = createAsyncThunk(
  'orders/updateOrdersAsync',
  async (payload) => {
    const response = await authRequest.put(`${API_ENDPOINTS.ORDERS}/${payload.id}`, payload);
    return response.data;
  }
);

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    updateOrders: (state, { payload }) => {
      state.ordersState = state.ordersState.map((item) => {
        let items = item;
        if (item._id === payload.id) {
          item.status = payload.status;
          items = { ...item };
        }
        return items;
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postOrdersAsync.pending, (state, action) => {
      toast.loading('Processing... Please Wait!!');
    });
    builder.addCase(postOrdersAsync.fulfilled, (state, { payload }) => {
      toast.dismiss();
      toast.success('Your Order is Successfully post!!!');
    });
    builder.addCase(postOrdersAsync.rejected, (state, { error: { message } }) => {
      toast.dismiss();
      toast.error(message);
    });
    builder.addCase(loadOrdersAsync.pending, (state, action) => {
      state.status = 'Pending';
    });
    builder.addCase(loadOrdersAsync.fulfilled, (state, { payload }) => {
      // Backend returns pageable response with content array
      state.ordersState = payload.content || payload || [];
      state.pagination = {
        totalElements: payload.totalElements || 0,
        totalPages: payload.totalPages || 0,
        size: payload.size || 10,
        number: payload.number || 0,
      };
      state.status = 'Success';
    });
    builder.addCase(loadOrdersAsync.rejected, (state, { error }) => {
      state.status = 'Rejected';
      state.ordersState = [];
      // Don't show toast error for failed order loads (user might not have orders yet)
      // Components can handle the error state if needed
    });
    builder.addCase(updateOrdersAsync.pending, (state, action) => {
      toast.loading('Updating order... Please Wait!!');
    });
    builder.addCase(updateOrdersAsync.fulfilled, (state, { payload }) => {
      toast.dismiss();
      toast.success('Order updated successfully');
    });

    builder.addCase(updateOrdersAsync.rejected, (state, { error: { message } }) => {
      toast.dismiss();
      toast.error(message);
    });
  },
});

export const { updateOrders } = ordersSlice.actions;

export default ordersSlice.reducer;
